import { render, staticRenderFns } from "./AbcVehicleData.vue?vue&type=template&id=680eae98"
import script from "./AbcVehicleData.vue?vue&type=script&lang=js"
export * from "./AbcVehicleData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports